class CartSubOfferButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.updateSubOffer.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.updateSubOffer);
  }

  updateSubOffer(e) {
    e.preventDefault();
    const isUpgrade = !this.classList.contains('sub-selected');
    const sellingPlan =
      this.closest('.cart-item').dataset.sellingPlan && isUpgrade
        ? this.closest('.cart-item').dataset.sellingPlan
        : null;
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

    this.closest('.cart-item').querySelector('.loading__spinner').classList.remove('hidden');

    const body = JSON.stringify({
      line: this.closest('.cart-item').dataset.index,
      selling_plan: sellingPlan,
      quantity: this.closest('.cart-item').querySelector('.quantity__input').dataset.cartQuantity,
      sections: cartItems.getSectionsToRender().map((section) => section.section),
    });

    this.reRenderAfterChange(body.line, body);
  }

  reRenderAfterChange(line, body) {
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const variantId = this.closest('.cart-item').dataset.variantId;

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          cartItems.updateLiveRegions(line, parsedState.errors);
          return;
        }

        cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        cartItems.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-sub-offer-button',
          cartData: parsedState,
          sellingPlan: JSON.parse(body).selling_plan,
        });
      })
      .catch((error) => {
        console.error(error);
        cartItems.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        cartItems.disableLoading(line);
      });
  }
}
customElements.define('sub-offer-button', CartSubOfferButton);

class CartGifts extends HTMLElement {
  connectedCallback() {
    window.addEventListener('DOMContentLoaded', () => {
      this.updateCartCount();
    });
    this.parentElement.addEventListener('click', this.clickHandler.bind(this));

    if (window.location.pathname === '/cart') {
      document.querySelector('main .cart__checkout-button').addEventListener('click', this.clickHandler.bind(this));
    }

    const debouncedOnChange = debounce(async (event) => {
      setTimeout(() => {
        this.updateCartCount();
      }, 200);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      debouncedOnChange(event);
    });
  }

  disconnectedCallback() {
    this.parentElement.removeEventListener('click', this.clickHandler);

    if (window.location.pathname === '/cart') {
      document.querySelector('main .cart__checkout-button').removeEventListener('click', this.clickHandler);
    } else {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }
  }

  updateCartCount() {
    const cartItems = Array.from(this.parentElement.querySelectorAll('cart-drawer-items:not(.cart-gifts) .cart-item'));

    const count = cartItems
      .filter((x) => !Boolean(x.dataset.freeGift))
      .map((v) => Number(v.dataset.quantity))
      .reduce((acc, curr) => {
        return acc + curr;
      }, 0);

    document.getElementById('CartDrawer').querySelector('.drawer__heading--cart-count').innerHTML = `(${count})`;
    document.getElementById('cart-icon-bubble') &&
      document.getElementById('cart-icon-bubble').querySelector('.cart-count-bubble') &&
      (document.getElementById('cart-icon-bubble').querySelector('.cart-count-bubble').innerHTML =
        `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count === 1 ? '1 item' : `${count} items`}</span>`);
  }

  doCheckout() {
    // other pre-checkout tasks can go here
    // comment this out to prevent checkout for debugging
    window.location.href = 'https://tryautobrush.com/checkout';
  }

  async clickHandler(e) {
    const { target } = e;
    if (target.closest('.cart__checkout-button')) {
      e.preventDefault();

      target.closest('.cart__checkout-button').setAttribute('disabled', true);
      target.closest('.cart__checkout-button').querySelector('.loading__spinner').classList.remove('hidden');

      // what needs to happen:
      // 1. gifts qualified by the server (in cart-drawer-items.cart-gifts) will be added
      // 2. qualified gift that are not part of the tiered gifts group can have a quantity greater than 1 if:
      //   a. different variants of the qualifying product are added
      //   b. specific variant line item quantity is greater than 1
      // 3. exclude gift(s) in cart count and savings calculations

      // get cart line items relevant data
      const cartItems = Array.from(
        this.parentElement.querySelectorAll('cart-drawer-items:not(.cart-gifts) .cart-item'),
      ).map((x) => {
        return {
          variantId: x.dataset.variantId,
          isGift: Boolean(x.dataset.freeGift),
          isTierGift: Boolean(x.dataset.tierGiftOffer),
          freeGiftId: x.dataset.freeGiftId,
          quantity: Number(x.dataset.quantity),
        };
      });

      // get qualified gifts
      const qualifiedGifts = Array.from(
        this.parentElement.querySelectorAll(
          // 'cart-drawer-items.cart-gifts .cart-item:not([data-limited-quantity="true"])',
          'cart-drawer-items.cart-gifts .cart-item',
        ),
      ).map((x) => {
        return {
          variantId: x.dataset.variantId,
          giftCount: Number(x.dataset.giftCount),
          isTierGift: Boolean(x.dataset.tierGiftOffer),
        };
      });
      const giftsInCart = cartItems
        .filter((item) => item.isGift)
        .map((v) => {
          return { variantId: v.variantId, quantity: v.quantity };
        });

      const removeGiftsList = giftsInCart.map((v) => {
        return { id: v.variantId, quantity: 0 };
      });

      const addGiftsList = qualifiedGifts.map((v) => {
        return { id: v.variantId, quantity: Number(v.giftCount) };
      });

      if (giftsInCart.length > 0) {
        await this.updateGiftItemQuantities(removeGiftsList)
          .then(async (res) => {
            console.info('remove gifts from cart results', res);
            if (qualifiedGifts.length > 0) {
              await this.addGiftItems(addGiftsList)
                .then((res) => {
                  console.info('add gifts to cart results', res);
                  this.doCheckout();
                })
                .catch((e) => {
                  console.error({ e });
                });
            }
          })
          .catch((e) => {
            console.error({ e });
          });
      } else {
        if (qualifiedGifts.length > 0) {
          await this.addGiftItems(addGiftsList)
            .then((res) => {
              console.info('add gifts to cart results', res);
              this.doCheckout();
            })
            .catch((e) => {
              console.error({ e });
            });
        } else {
          this.doCheckout();
        }
      }

      return console.debug({
        cartItems,
        qualifiedGifts,
        giftsInCart,
        removeGiftsList,
      });

      this.doCheckout();
    }
  }

  async addGiftItems(giftItems) {
    const items = giftItems.map((v) => ({ id: v.id, quantity: v.quantity }));
    const body = JSON.stringify({ items: items });
    const results = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } }).then((response) =>
      response.json(),
    );

    return results;
  }

  async updateGiftItemQuantities(giftItems) {
    const updates = {};
    giftItems.forEach((item) => {
      updates[item.id] = item.quantity;
    });
    const body = JSON.stringify({ updates });
    const results = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then((response) =>
      response.json(),
    );

    return results;
  }
}
customElements.define('cart-gifts', CartGifts);
